import { Form, useActionData, useNavigation } from 'react-router-dom';
import { Button, Container, FormField, Input } from '@dma/ui';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import { staticSeo } from '../../../app/seo/static-seo.content';
import './LoginPage.css';

interface LoginActionFailure {
  ok: false;
  message: string;
}

/**
 * Public route (`/admin/login`), rendered outside the protected AdminLayout.
 * Submits via the route's own `action` (see features/admin/routes.tsx) using a
 * navigating `<Form>` — unlike ContactForm's `useFetcher`, a real navigation
 * is exactly what we want here: success means redirecting to `/admin`.
 */
export function LoginPage() {
  const actionData = useActionData() as LoginActionFailure | undefined;
  const navigation = useNavigation();
  const isSubmitting = navigation.state === 'submitting';
  // Outside AdminLayout, so it needs its own noIndex — AdminLayout's call
  // only covers pages nested under the 'admin-root' route.
  useDocumentHead(staticSeo.adminGeneric, { noIndex: true });

  return (
    <div className="dma-admin-login">
      <Container>
        <div className="dma-admin-login__panel">
          <p className="dma-admin-login__eyebrow">پنل مدیریت</p>
          <h1 className="dma-admin-login__title">داریوش معدن آذر</h1>

          <Form method="post" className="dma-admin-login__form" noValidate>
            {actionData && actionData.ok === false ? (
              <p className="dma-admin-login__error" role="alert">
                {actionData.message}
              </p>
            ) : null}

            <FormField label="ایمیل" htmlFor="email" required>
              <Input
                id="email"
                name="email"
                type="email"
                required
                autoFocus
                autoComplete="username"
                disabled={isSubmitting}
              />
            </FormField>

            <FormField label="رمز عبور" htmlFor="password" required>
              <Input
                id="password"
                name="password"
                type="password"
                required
                minLength={6}
                autoComplete="current-password"
                disabled={isSubmitting}
              />
            </FormField>

            <Button type="submit" disabled={isSubmitting} className="dma-admin-login__submit">
              {isSubmitting ? 'در حال ورود...' : 'ورود'}
            </Button>
          </Form>
        </div>
      </Container>
    </div>
  );
}
